/**
 * Simple Blog Pagination
 * Handles pagination by showing/hiding blog posts in the DOM
 */

(function() {
  // Prevent duplicate declarations
  if (window.SimpleBlogPagination) {
    return;
  }

  class SimpleBlogPagination {
  constructor(section) {
    this.section = section;
    this.articleLimit = parseInt(section.dataset.articleLimit) || 12;
    this.currentPage = 1;
    this.hasUserInteracted = false;
    
    this.postsContainer = section.querySelector('.blog-posts-container');
    this.paginationContainer = section.querySelector('[data-pagination]');
    
    if (!this.postsContainer || !this.paginationContainer) return;
    
    // Get all articles
    this.articles = this.postsContainer.querySelectorAll('.article');
    this.totalArticles = this.articles.length;
    this.totalPages = Math.ceil(this.totalArticles / this.articleLimit);
    
    console.log('SimpleBlogPagination initialized:', {
      totalArticles: this.totalArticles,
      articleLimit: this.articleLimit,
      totalPages: this.totalPages
    });
    
    if (this.totalPages > 1) {
      this.init();
      // Use requestAnimationFrame to ensure DOM is ready before showing page
      requestAnimationFrame(() => {
        this.showPage(1, false); // Don't scroll on initial load
      });
    } else {
      // Hide pagination if only one page
      this.paginationContainer.style.display = 'none';
    }
  }
  
  init() {
    // Update pagination HTML
    this.updatePaginationHTML();
    
    // Bind event handlers
    const prevButton = this.paginationContainer.querySelector('[data-action="prev"]');
    const nextButton = this.paginationContainer.querySelector('[data-action="next"]');
    const pageNumbers = this.paginationContainer.querySelectorAll('[data-page]');
    
    if (prevButton) {
      prevButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.hasUserInteracted = true;
        if (this.currentPage > 1) {
          this.showPage(this.currentPage - 1);
        }
      });
    }
    
    if (nextButton) {
      nextButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.hasUserInteracted = true;
        if (this.currentPage < this.totalPages) {
          this.showPage(this.currentPage + 1);
        }
      });
    }
    
    pageNumbers.forEach(page => {
      page.addEventListener('click', (e) => {
        e.preventDefault();
        this.hasUserInteracted = true;
        const pageNum = parseInt(e.target.dataset.page);
        if (pageNum !== this.currentPage) {
          this.showPage(pageNum);
        }
      });
    });
  }
  
  getVisiblePages() {
    const total = this.totalPages;
    const current = this.currentPage;
    const pages = [];

    // Collect pages that should always be visible
    const visible = new Set();
    visible.add(1);
    visible.add(total);
    for (let i = current - 1; i <= current + 1; i++) {
      if (i >= 1 && i <= total) visible.add(i);
    }

    let prev = 0;
    for (let i = 1; i <= total; i++) {
      if (visible.has(i)) {
        if (prev && i - prev > 1) {
          pages.push('...');
        }
        pages.push(i);
        prev = i;
      }
    }

    return pages;
  }

  updatePaginationHTML() {
    // Clear existing pagination
    this.paginationContainer.innerHTML = '';

    // Create prev button
    const prevButton = document.createElement('button');
    prevButton.className = 'pagination__button pagination__prev';
    prevButton.setAttribute('data-action', 'prev');
    prevButton.textContent = 'Previous';
    prevButton.disabled = true;
    this.paginationContainer.appendChild(prevButton);

    // Create page numbers container
    const pagesContainer = document.createElement('div');
    pagesContainer.className = 'pagination__pages';

    this.getVisiblePages().forEach(entry => {
      if (entry === '...') {
        const ellipsis = document.createElement('span');
        ellipsis.className = 'pagination__ellipsis';
        ellipsis.textContent = '...';
        pagesContainer.appendChild(ellipsis);
      } else {
        const pageSpan = document.createElement('span');
        pageSpan.className = 'pagination__page';
        if (entry === this.currentPage) pageSpan.classList.add('pagination__page--current');
        pageSpan.setAttribute('data-page', entry);
        pageSpan.textContent = entry;
        pagesContainer.appendChild(pageSpan);
      }
    });

    this.paginationContainer.appendChild(pagesContainer);

    // Create next button
    const nextButton = document.createElement('button');
    nextButton.className = 'pagination__button pagination__next';
    nextButton.setAttribute('data-action', 'next');
    nextButton.textContent = 'Next';
    if (this.totalPages <= 1) nextButton.disabled = true;
    this.paginationContainer.appendChild(nextButton);
  }
  
  showPage(page, shouldScroll = true) {
    console.log('Showing page:', page, 'shouldScroll:', shouldScroll);
    
    // Set loading state
    this.postsContainer.setAttribute('data-loading', 'true');
    
    // Calculate which articles to show
    const startIndex = (page - 1) * this.articleLimit;
    const endIndex = startIndex + this.articleLimit;
    
    // Show/hide articles
    this.articles.forEach((article, index) => {
      if (index >= startIndex && index < endIndex) {
        article.style.display = '';
        // Trigger animations if needed
        const aosElements = article.querySelectorAll('[data-aos]');
        aosElements.forEach(el => {
          el.classList.add('aos-animate');
        });
      } else {
        article.style.display = 'none';
      }
    });
    
    // Update current page
    this.currentPage = page;
    
    // Update pagination buttons
    this.updatePaginationButtons();
    
    // Only scroll if requested and not on initial page load
    if (shouldScroll) {
      // Check if this is a user-initiated action (not initial page load)
      const isMobile = window.innerWidth < 750;
      const isInitialLoad = performance.navigation.type === 1 || performance.navigation.type === 0;
      
      // Skip scrolling on mobile initial page load
      if (isMobile && isInitialLoad && !this.hasUserInteracted) {
        console.log('Skipping scroll on mobile initial load');
        return;
      }
      
      // Small delay to ensure DOM updates are complete
      setTimeout(() => {
        const sectionTop = this.section.offsetTop;
        const headerHeight = document.querySelector('[data-header-height]')?.offsetHeight || 0;
        
        window.scrollTo({
          top: sectionTop - headerHeight - 20,
          behavior: 'smooth'
        });
      }, 100);
    }
    
    // Remove loading state
    setTimeout(() => {
      this.postsContainer.setAttribute('data-loading', 'false');
    }, 300);
  }
  
  updatePaginationButtons() {
    const prevButton = this.paginationContainer.querySelector('[data-action="prev"]');
    const nextButton = this.paginationContainer.querySelector('[data-action="next"]');

    // Update prev/next buttons
    if (prevButton) {
      prevButton.disabled = this.currentPage <= 1;
    }

    if (nextButton) {
      nextButton.disabled = this.currentPage >= this.totalPages;
    }

    // Rebuild page numbers since the visible set changes per page
    const pagesContainer = this.paginationContainer.querySelector('.pagination__pages');
    if (pagesContainer) {
      pagesContainer.innerHTML = '';

      this.getVisiblePages().forEach(entry => {
        if (entry === '...') {
          const ellipsis = document.createElement('span');
          ellipsis.className = 'pagination__ellipsis';
          ellipsis.textContent = '...';
          pagesContainer.appendChild(ellipsis);
        } else {
          const pageSpan = document.createElement('span');
          pageSpan.className = 'pagination__page';
          if (entry === this.currentPage) pageSpan.classList.add('pagination__page--current');
          pageSpan.setAttribute('data-page', entry);
          pageSpan.textContent = entry;
          pageSpan.addEventListener('click', (e) => {
            e.preventDefault();
            this.hasUserInteracted = true;
            const pageNum = parseInt(e.target.dataset.page);
            if (pageNum !== this.currentPage) {
              this.showPage(pageNum);
            }
          });
          pagesContainer.appendChild(pageSpan);
        }
      });
    }
  }
  }

  // Make class available globally
  window.SimpleBlogPagination = SimpleBlogPagination;

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    // Small delay to prevent scroll issues on mobile
    setTimeout(() => {
      const blogSections = document.querySelectorAll('.blog-section');
      
      console.log('Simple Blog Pagination: Found', blogSections.length, 'blog sections');
      
      blogSections.forEach((section, index) => {
        console.log(`Initializing pagination for section ${index + 1}`);
        new SimpleBlogPagination(section);
      });
    }, 100);
  });

  // Re-initialize on Shopify section load (for theme editor)
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('.blog-section');
    if (section) {
      console.log('Simple Blog Pagination: Re-initializing after section load');
      new SimpleBlogPagination(section);
    }
  });
})(); 